import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { resetPassword } from "../../Api/ApiUrlConst"; // API call
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ResetPassword() {
  const [form, setForm] = useState({
    email: "",
    newPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await resetPassword(form);
      setForm({ email: "", newPassword: "" });

      toast.success("✅ Password reset successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("❌ Failed to reset password.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };


  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md="6" lg="5">
            <Card className="shadow-lg border-0 rounded-3" style={{ marginBottom: "300px" }}>
              <CardBody className="p-4">
                <CardTitle
                  tag="h3"
                  className="text-center mb-4 fw-bold text-dark"
                >
                  🔑 Reset Password
                </CardTitle>

                <Form onSubmit={handleSubmit} >
                  {/* Email */}
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                      id="email"
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                      className="rounded-pill shadow-sm"
                    />
                  </FormGroup>


                  {/* New Password */}
                  <FormGroup>
                    <Label for="newPassword">New Password</Label>
                    <InputGroup>
                      <Input
                        id="newPassword"
                        type={showPassword ? "text" : "password"}
                        name="newPassword"
                        value={form.newPassword}
                        onChange={handleChange}
                        placeholder="Enter new password"
                        required
                        className="rounded-start-pill shadow-sm"
                      />
                      <InputGroupText
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer", background: "#fff" }}
                        className="rounded-end-pill"
                      >
                        {showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}

                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    color="primary"
                    className="w-100 rounded-pill shadow-sm fw-semibold"
                  >
                    Reset Password
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ResetPassword;
